import React from 'react';
import { JobResult } from '../types/job';

interface Props {
  result: JobResult;
}

const JobCard: React.FC<Props> = ({ result }) => {
  const jobId = result.job_id?.raw || '';
  const jobTitle = result?.job_title?.raw ?? 'No Title';
  const location = result?.location?.raw ?? 'No Location';
  const friendlySalary = result?.friendly_salary?.raw;
  const salary = result?.salary?.raw ?? '';
  const offsitePreference = result?.offsite_preference_name?.raw ?? null;
  const postedDate = result?.posted_date?.raw ?? null;
  const formattedDate = postedDate
    ? new Date(postedDate).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'UTC',
    })
    : 'No Date';
  const jobLink = `${window.aqJobsOptions.relativeListingUrl}/${jobId}`;
  const base = 'job-card';
  const title = jobTitle.replace(/<\/?em>/g, '');
  const classes = {
    wrapper: base,
    block: `${base}__block`,
    title: `${base}__title`,
    location: `${base}__location`,
    salary: `${base}__salary`,
    separator: `${base}__separator`,
    time: `${base}__time`,
  };
  // Check if the job is new (posted within the last 7 days)
  const isNewJob = (date) => {
    const postedDateObj = new Date(date);
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

    return postedDateObj >= sevenDaysAgo;
  };

  return (
    <a href={jobLink} title={title} className={classes.wrapper}>
      <div className={classes.block} role="region" aria-labelledby={`job-title-${jobId}`}>
        <h2 className={classes.title} id={`job-title-${jobId}`}>{jobTitle.replace(/<\/?em>/g, '')}</h2>
        <p className={classes.location}>
          {location} {offsitePreference && (
          <>
            <span className={classes.separator}> | </span> {offsitePreference}
          </>
          )}
        </p>
        {friendlySalary ? (
          <p className={classes.salary}>{friendlySalary}</p>
        ) : (
          <p className={classes.salary}>{salary}</p>
        )}
        <time
          className={`${classes.time} ${isNewJob(result.posted_date?.raw) ? 'job-card__posted--new' : ''}`}
          itemProp="datePublished"
        >
          Posted {formattedDate}
        </time>
      </div>
    </a>

  );
};
export default JobCard;
